import Button from 'components/shared/button/button';
import Image from 'components/shared/image';
import RichText from 'components/shared/richtext';
import useIsMobile from 'hooks/utils/useIsMobile';
import styles from './ctaLadder.module.scss';

const CtaLadder = ({ data, locale }) => {
  const { ctaSteps } = data;

  return (
    <div id="sectionCtaLadder" className={styles.ladderWrapper}>
      {ctaSteps.map((ctaStep, index) => (
        <CtaStep key={ctaStep.headline} locale={locale} stepData={ctaStep} stepIndex={index} />
      ))}
    </div>
  );
};

export default CtaLadder;

const CtaStep = ({ stepData, stepIndex, locale }) => {
  const { headline, body, media, button, style } = stepData;
  const isMobile = useIsMobile();
  const decideCtaStepClass = () => (stepIndex % 2 === 0 ? styles.ctaStepV1 : styles.ctaStepV2);

  return (
    <div className={decideCtaStepClass()}>
      {!isMobile && (
        <>
          {style === 'Image on left side' && (
            <>
              <div className={styles.ctaStepImage}>
                <Image src={media.image} layout="fill" loading="eager" priority sizes="50vw" />
              </div>
              <div className={styles.ctaStepTextWrapperRight}>
                <h2 className={styles.ctaStepHeadline}>{headline}</h2>
                <RichText className={styles.ctaStepBody} text={body?.json} />
                {button && (
                  <Button className={styles.ctaStepButton} locale={locale} button={button} />
                )}
              </div>
            </>
          )}
          {style === 'Image on right side' && (
            <>
              <div className={styles.ctaStepTextWrapperLeft}>
                <h2 className={styles.ctaStepHeadline}>{headline}</h2>
                <RichText className={styles.ctaStepBody} text={body?.json} />
                {button && (
                  <Button className={styles.ctaStepButton} locale={locale} button={button} />
                )}
              </div>
              <div className={styles.ctaStepImage}>
                <Image src={media.image} layout="fill" loading="eager" priority sizes="50vw" />
              </div>
            </>
          )}
        </>
      )}
      {isMobile && (
        <>
          <div className={styles.ctaStepImage}>
            <Image src={media.image} layout="fill" loading="eager" priority />
          </div>
          <div className={styles.ctaStepTextWrapperRight}>
            <h2 className={styles.ctaStepHeadline}>{headline}</h2>
            <RichText className={styles.ctaStepBody} text={body.json} />
            {button && <Button className={styles.ctaStepButton} locale={locale} button={button} />}
          </div>
        </>
      )}
    </div>
  );
};
